import { t } from "./i18n.js";

const Translations = {
    intlPhoneInput: {
        af: "Afeganistão",
        al: "Albânia",
        dz: "Argélia",
        as: "Samoa Americana",
        ad: "Andorra",
        ao: "Angola",
        ai: "Anguilla",
        ag: "Antígua e Barbuda",
        ar: "Argentina",
        am: "Armênia",
        aw: "Aruba",
        ac: "Ilha da Ascensão",
        au: "Austrália",
        at: "Áustria",
        az: "Azerbaijão",
        bs: "Bahamas",
        bh: "Bahrain",
        bd: "Bangladesh",
        bb: "Barbados",
        by: "Belarus",
        be: "Bélgica",
        bz: "Belize",
        bj: "Benin",
        bm: "Butão",
        bt: "Bolívia",
        ba: "Bósnia e Herzegovina",
        bw: "Botsuana",
        br: "Brasil",
        io: "Território Britânico do Oceano Índico",
        vg: "Ilhas Virgens Britânicas",
        bn: "Brunei",
        bg: "Bulgária",
        bf: "Burkina Faso",
        bi: "Burundi",
        kh: "Camboja",
        cm: "Camarões",
        ca: "Canadá",
        cv: "Cabo Verde",
        bq: "Países Baixos Caribenhos",
        ky: "Ilhas Cayman",
        cf: "República Centro-Africana",
        td: "Chade",
        cl: "Chile",
        cn: "China",
        cx: "Ilha do Natal",
        cc: "Ilhas Cocos (Keeling)",
        co: "Colômbia",
        km: "Comores",
        cg: "Congo - Brazzaville",
        cd: "Congo - Kinshasa",
        ck: "Ilhas Cook",
        cr: "Costa Rica",
        ci: "Costa do Marfim",
        hr: "Croácia",
        cu: "Cuba",
        cw: "Curaçao",
        cy: "Chipre",
        cz: "República Tcheca",
        dk: "Dinamarca",
        dj: "Djibouti",
        dm: "Dominica",
        do: "República Dominicana",
        ec: "Equador",
        eg: "Egito",
        sv: "El Salvador",
        gq: "Guiné Equatorial",
        er: "Eritreia",
        ee: "Estônia",
        sz: "Suazilândia",
        et: "Etiópia",
        fk: "Ilhas Falkland",
        fo: "Ilhas Faroe",
        fj: "Fiji",
        fi: "Finlândia",
        fr: "França",
        gf: "Guiana Francesa",
        pf: "Polinésia Francesa",
        ga: "Gabão",
        gm: "Gâmbia",
        ge: "Geórgia",
        de: "Alemanha",
        gh: "Gana",
        gi: "Gibraltar",
        gr: "Grécia",
        gl: "Groenlândia",
        gd: "Granada",
        gp: "Guadalupe",
        gu: "Guam",
        gt: "Guatemala",
        gg: "Guernsey",
        gn: "Guiné",
        gw: "Guiné-Bissau",
        gy: "Guiana",
        ht: "Haiti",
        hn: "Honduras",
        hk: "Hong Kong",
        hu: "Hungria",
        is: "Islândia",
        in: "Índia",
        id: "Indonésia",
        ir: "Irã",
        iq: "Iraque",
        ie: "Irlanda",
        im: "Ilha de Man",
        il: "Israel",
        it: "Itália",
        jm: "Jamaica",
        jp: "Japão",
        je: "Jersey",
        jo: "Jordânia",
        kz: "Cazaquistão",
        ke: "Quênia",
        ki: "Kiribati",
        xk: "Kosovo",
        kw: "Kuwait",
        kg: "Quirguistão",
        la: "Laos",
        lv: "Letônia",
        lb: "Líbano",
        ls: "Lesoto",
        lr: "Libéria",
        ly: "Líbia",
        li: "Liechtenstein",
        lt: "Lituânia",
        lu: "Luxemburgo",
        mo: "Macau",
        mg: "Madagascar",
        mw: "Malawi",
        my: "Malásia",
        mv: "Maldivas",
        ml: "Mali",
        mt: "Malta",
        mh: "Ilhas Marshall",
        mq: "Martinica",
        mr: "Mauritânia",
        mu: "Maurício",
        yt: "Mayotte",
        mx: "México",
        fm: "Micronésia",
        md: "Moldávia",
        mc: "Mônaco",
        mn: "Mongólia",
        me: "Montenegro",
        ms: "Montserrat",
        ma: "Marrocos",
        mz: "Moçambique",
        mm: "Mianmar (Birmânia)",
        na: "Namíbia",
        nr: "Nauru",
        np: "Nepal",
        nl: "Países Baixos",
        nc: "Nova Caledônia",
        nz: "Nova Zelândia",
        ni: "Nicarágua",
        ne: "Níger",
        ng: "Nigéria",
        nu: "Niue",
        nf: "Ilha Norfolk",
        kp: "Coreia do Norte",
        mk: "Macedônia do Norte",
        mp: "Ilhas Marianas do Norte",
        no: "Noruega",
        om: "Omã",
        pk: "Paquistão",
        pw: "Palau",
        ps: "Palestina",
        pa: "Panamá",
        pg: "Papua Nova Guiné",
        py: "Paraguai",
        pe: "Peru",
        ph: "Filipinas",
        pl: "Polônia",
        pt: "Portugal",
        pr: "Porto Rico",
        qa: "Catar",
        re: "Reunião",
        ro: "Romênia",
        ru: "Rússia",
        rw: "Ruanda",
        ws: "Samoa",
        sm: "San Marino",
        st: "São Tomé e Príncipe",
        sa: "Arábia Saudita",
        sn: "Senegal",
        rs: "Sérvia",
        sc: "Seychelles",
        sl: "Serra Leoa",
        sg: "Singapura",
        sx: "Sint Maarten",
        sk: "Eslováquia",
        si: "Eslovênia",
        sb: "Ilhas Salomão",
        so: "Somália",
        za: "África do Sul",
        kr: "Coreia do Sul",
        ss: "Sudão do Sul",
        es: "Espanha",
        lk: "Sri Lanka",
        bl: "São Bartolomeu",
        sh: "Santa Helena",
        kn: "São Cristóvão e Nevis",
        lc: "Santa Lúcia",
        mf: "São Martinho",
        pm: "São Pedro e Miquelão",
        vc: "São Vicente e Granadinas",
        sd: "Sudão",
        sr: "Suriname",
        sj: "Svalbard e Jan Mayen",
        se: "Suécia",
        ch: "Suíça",
        sy: "Síria",
        tw: "Taiwan",
        tj: "Tajiquistão",
        tz: "Tanzânia",
        th: "Tailândia",
        tl: "Timor-Leste",
        tg: "Togo",
        tk: "Tokelau",
        to: "Tonga",
        tt: "Trinidad e Tobago",
        tn: "Tunísia",
        tr: "Turquia",
        tm: "Turcomenistão",
        tc: "Ilhas Turcas e Caicos",
        tv: "Tuvalu",
        ug: "Uganda",
        ua: "Ucrânia",
        ae: "Emirados Árabes Unidos",
        gb: "Reino Unido",
        us: "Estados Unidos",
        uy: "Uruguai",
        vi: "Ilhas Virgens Americanas",
        uz: "Uzbequistão",
        vu: "Vanuatu",
        va: "Cidade do Vaticano",
        ve: "Venezuela",
        vn: "Vietnã",
        wf: "Wallis e Futuna",
        eh: "Saara Ocidental",
        ye: "Iêmen",
        zm: "Zâmbia",
        zw: "Zimbábue",
        ax: "Ilhas Åland",
        selectedCountryAriaLabel: "País selecionado",
        noCountrySelected: "Nenhum país selecionado",
        countryListAriaLabel: "Lista de países",
        searchPlaceholder: "Pesquisar",
        zeroSearchResults: "Nenhum resultado encontrado",
        oneSearchResult: "1 resultado encontrado",
        multipleSearchResults: "${count} resultados encontrados",
    },
    filePondLabels: {
        labelIdle: 'Arraste e solte os arquivos ou <span class="filepond--label-action"> Clique aqui </span>',
        labelInvalidField: "Arquivos inválidos",
        labelFileWaitingForSize: "Calculando o tamanho do arquivo",
        labelFileSizeNotAvailable: "Tamanho do arquivo indisponível",
        labelFileLoading: "Carregando",
        labelFileLoadError: "Erro durante o carregamento",
        labelFileProcessing: "Enviando",
        labelFileProcessingComplete: "Envio finalizado",
        labelFileProcessingAborted: "Envio cancelado",
        labelFileProcessingError: "Erro durante o envio",
        labelFileProcessingRevertError: "Erro ao reverter o envio",
        labelFileRemoveError: "Erro ao remover o arquivo",
        labelTapToCancel: "clique para cancelar",
        labelTapToRetry: "clique para reenviar",
        labelTapToUndo: "clique para desfazer",
        labelButtonRemoveItem: "Remover",
        labelButtonAbortItemLoad: "Abortar",
        labelButtonRetryItemLoad: "Reenviar",
        labelButtonAbortItemProcessing: "Cancelar",
        labelButtonUndoItemProcessing: "Desfazer",
        labelButtonRetryItemProcessing: "Reenviar",
        labelButtonProcessItem: "Enviar",
        labelMaxFileSizeExceeded: "Arquivo é muito grande",
        labelMaxFileSize: "O tamanho máximo permitido: {filesize}",
        labelMaxTotalFileSizeExceeded: "Tamanho total dos arquivos excedido",
        labelMaxTotalFileSize: "Tamanho total permitido: {filesize}",
        labelFileTypeNotAllowed: "Tipo de arquivo inválido",
        fileValidateTypeLabelExpectedTypes: "Tipos de arquivo suportados são {allButLastType} ou {lastType}",
        imageValidateSizeLabelFormatError: "Tipo de imagem inválida",
        imageValidateSizeLabelImageSizeTooSmall: "Imagem muito pequena",
        imageValidateSizeLabelImageSizeTooBig: "Imagem muito grande",
        imageValidateSizeLabelExpectedMinSize: "Tamanho mínimo permitida: {minWidth} × {minHeight}",
        imageValidateSizeLabelExpectedMaxSize: "Tamanho máximo permitido: {maxWidth} × {maxHeight}",
        imageValidateSizeLabelImageResolutionTooLow: "Resolução muito baixa",
        imageValidateSizeLabelImageResolutionTooHigh: "Resolução muito alta",
        imageValidateSizeLabelExpectedMinResolution: "Resolução mínima permitida: {minResolution}",
        imageValidateSizeLabelExpectedMaxResolution: "Resolução máxima permitida: {maxResolution}"

    }


}

// Traduções: o texto em português é a chave de t() (lang/parts/js.keys.json). Países usam Intl.DisplayNames
// quando o idioma da página não é pt-BR (a lista em português fica como fonte/fallback).
const pageLang = (document.documentElement.lang || 'pt-BR').replace('_', '-');
let countryNames = null;
if (pageLang.toLowerCase() !== 'pt-br' && typeof Intl !== 'undefined' && Intl.DisplayNames) {
    try {
        countryNames = new Intl.DisplayNames([pageLang], {type: 'region'});
    } catch (e) {
        countryNames = null;
    }
}

for (const [key, value] of Object.entries(Translations.intlPhoneInput)) {
    if (/^[a-z]{2}$/.test(key)) {
        try {
            Translations.intlPhoneInput[key] = (countryNames && countryNames.of(key.toUpperCase())) || value;
        } catch (e) {
            // mantém o nome em português
        }
    } else {
        Translations.intlPhoneInput[key] = t(value);
    }
}

for (const [key, value] of Object.entries(Translations.filePondLabels)) {
    Translations.filePondLabels[key] = t(value);
}

export default Translations;
